module.exports = __webpack_public_path__ + "img/Sakralbau_6_b.6d5a6677.jpg";